import React, { useEffect, useContext } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';

//components 
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Badge from "beaktShared/components/Badge/Badge.js";

import CardBody from "beaktShared/components/Card/CardBody.js";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "beaktShared/components/CustomButtons/Button.js";

//services
import { transformValueFloattoFormated } from "beaktShared/helpers/masks";
import { UsePostApi, UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

//styles
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(styles);


export default function VisualizarTodosFranqueados({ closemodal, showmodal, periodo}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);
  const [notification, setNotification] = React.useState({
    show: false,
    color: 'info',
    message: ''
  });
  const showNotification = (message, color) => {
    setNotification({
      show: true,
      color: color,
      message: message
    });
    setTimeout(function () {
      setNotification({ show: false });
    }, 6000);
  };

  useEffect(() => {
    loadVisualizarTodosEstabelecimento(periodo);
  }, [showmodal])


  const [dadosEstabelecimento, setdadosEstabelecimento] = React.useState([]);
  const [loadingEstabelecimento, setloadingEstabelecimento] = React.useState([]);
  const [dataCSV,setdataCSV] = React.useState([]);  

  const loadVisualizarTodosEstabelecimento = (obj) => {
    setloadingEstabelecimento(true);
    const endPoint = "dashboard/top5estabelecimentobyvenda/" + session.franquiaId + "/" + 0;
    UsePostApi(endPoint, obj).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger')
        setloadingEstabelecimento(false);
        return false;
      }
      let newlist = [];
      result.data.map((item, index) => (
        newlist.push({
          posicao: (index + 1) + "º",
          estabelecimento: item.estabelecimento,
          total: transformValueFloattoFormated(item.total),
          qtd: item.qtd
        })
      ));

      setdadosEstabelecimento(newlist);
      setloadingEstabelecimento(false);
      setdataCSV(newlist);
      return true;
    });
  }

  const columnsProps = [
    {
      Header: t('dashboard.ranking'),
      accessor: "posicao",
    },
    {
      Header: t('label.establishment'),
      accessor: "estabelecimento",
    },
    {
      Header: 'R$ '+ t('label.total'),
      accessor: "total",
      // Cell: (props) => <div> {transformValueFloattoFormated(props.value)} </div>  

    },
    {
      Header: t('label.qty_sales'),
      accessor: "qtd",
      Cell: (props) => <div> <Badge color="success">{(props.value)}</Badge></div>
    },
  ]
  let columns = [...columnsProps];    

  const handleCloseModalFranqueados = () => {
    closemodal(false);
  }

  // *******************************************************************************
  // ********************************** CABEÇALHO CSV **********************************
  // *******************************************************************************

  const columnsCSV = [
    { displayName: "Ranking", id: "posicao" },
    { displayName: "Estabelecimento", id: "estabelecimento" },
    { displayName: "R$ Total", id: "total" },
    { displayName: "Qtd Vendas", id: "qtd" }
  ];

  return (
    <div>

      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal + ' ' + classes.modalLarge
        }}
        fullWidth
        maxWidth="lg"
        open={showmodal}
        keepMounted
        onClose={() => handleCloseModalFranqueados()}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
          style={{ background: '#5c4477' }}
        >
          <h4 className={classes.modalTitle} style={{ color: 'white' }}>Todos Franqueados</h4>
        </DialogTitle>
        <DialogContent id="classic-modal-slide-description"
          className={classes.modalBody}
        >
          <CardBody>
          <GridContainer>
              <GridItem xs={12} sm={12} md={12}>

                {dataCSV.length > 0 &&

                  <div>
                    <div style={{ float: 'right' }}>
                      <CsvDownloader
                        filename="TodosFranqueados"
                        columns={columnsCSV}
                        datas={dataCSV}
                        separator={";"}>
                        <Button round color="default" size="sm" >CSV</Button>
                      </CsvDownloader>
                    </div><div style={{ clear: 'both' }}></div>
                  </div>
                }
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <ReactTable
                      loading={loadingEstabelecimento}
                      data={dadosEstabelecimento}
                      columns={columns}
                      filterable
                      // defaultFilterMethod={noCaseSensitive}
                      defaultPageSize={10}
                      minRows={5}
                      showPaginationBottom={true}
                      className="-striped -highlight"
                      previousText='Anterior'
                      nextText='Próximo'
                      loadingText='Carregando...'
                      noDataText='Nenhum registro encontrado!'
                      pageText='Página'
                      ofText='de'
                      rowsText='linhas'
                    />
              </GridItem>
            </GridContainer>
          </CardBody>
        </DialogContent>
      </Dialog>

    </div>
  );
}
